export const SAVED_INVESTMENT_START = "SAVED_INVESTMENT_START";
export const GET_SAVED_INVESTMENT = "GET_SAVED_INVESTMENT";
export const GET_SAVED_INVESTMENTS_SUCCESS = "GET_SAVED_INVESTMENT_SUCCESS";
export const GET_SAVED_INVESTMENTS_FAIL = "GET_SAVED_INVESTMENT_FAIL";
export const GET_SEARCHED_SAVED_INVESTMENTS = "GET_SEARCHED_SAVED_INVESTMENTS";
export const DELETE_SAVED_INVESTMENTS = "DELETE_SAVED_INVESTMENTS";
